import React from 'react'
import { type IUser } from '../../../models/User'
import { Box, Typography, useTheme } from '@mui/material'
import { black } from '../../../colors'
import { StudentEnrollmentListItem } from './StudentEnrollmentListItem'

interface StudentListSectionProps {
  title: string
  students: IUser[]
  enrolled?: boolean
  onAction: (userId: string) => void
  readOnly?: boolean
  sectionId?: string
}
export const StudentListSection: React.FC<StudentListSectionProps> = ({
  title,
  students,
  enrolled = false,
  onAction,
  readOnly,
  sectionId
}) => {
  const theme = useTheme()
  return (
    <>
      <Typography sx={{ mt: 3 }} variant='h5' fontSize={theme.spacing(4)} color={black[100]}>
        {title} ({students?.length >= 20 ? '20+' : students?.length || 0})
      </Typography>
      <Box>
        {students?.slice(0, 20).map((student: IUser, index: number) => (
          <StudentEnrollmentListItem
            enrolled={enrolled}
            key={student?.userId ?? `error-${index}`}
            index={index}
            handlePressed={() => { onAction(student?.userId) }}
            readOnly={readOnly}
            student={student}
            sectionId={sectionId}
          />
        ))}
      </Box>
    </>
  )
}
